module.exports = __webpack_public_path__ + "img/1722496391459-IMG_0299.jpeg.d1b93020.webp";